import script from "./GuardianChildrenSchedule.vue?vue&type=script&setup=true&lang=js"
export * from "./GuardianChildrenSchedule.vue?vue&type=script&setup=true&lang=js"

import "./GuardianChildrenSchedule.vue?vue&type=style&index=0&id=5bb12f85&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bb12f85"]])

export default __exports__